import { render, staticRenderFns } from "./WaitRewardByAccount.vue?vue&type=template&id=68380e8a&scoped=true&"
import script from "./WaitRewardByAccount.vue?vue&type=script&lang=js&"
export * from "./WaitRewardByAccount.vue?vue&type=script&lang=js&"
import style0 from "./WaitRewardByAccount.vue?vue&type=style&index=0&id=68380e8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68380e8a",
  null
  
)

export default component.exports